// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"254":"a69fee81","453":"bdead493"}[chunkId] + ".chunk.js";
};